import angular from 'angular';

const name = 'mmsCompareTo';
export const CompareToDirective = {
    name,
    directive: directive
};

function directive() {
    'ngInject';
    return {
        restrict: 'A',
        scope: true,
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModel) {
            let compareToModel;
            $scope.$watch($attrs[name], (newValue) => {
                compareToModel = newValue;
                ngModel.$validate();
            });

            ngModel.$validators[name] = (modelValue, viewValue) => {
                return viewValue === compareToModel;
            };
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/compareTo.directive.js